import React, { useState } from 'react'
import Menu1 from "../Menu";
import Header from '../Header';
import Footer from '../Footer';
import { Modal } from 'antd';
import { Select } from 'antd';
import { Table, Tag, Space } from 'antd';
import { DatePicker, TimePicker } from 'antd'
import { useNavigate } from 'react-router-dom';

const { Option } = Select;
const { RangePicker } = DatePicker;

const StoresList = [
    {
        Label: "Connect Store - ITPB",
        Value: 1
    },
    {
        Label: "Connect Store- Indiranagar",
        Value: 2
    },
    {
        Label: "Sarjapur",
        Value: 3
    },
    {
        Label: "Anubhava (New Airport Road)",
        Value: 4
    },
    {
        Label: "EVA Mall - Brigade",
        Value: 5
    },
    {
        Label: "R-city(Mumbai)",
        Value: 6
    },
    {
        Label: "Amanora Mall",
        Value: 7
    },
    {
        Label: "OMR Padur(Chennai)",
        Value: 8
    },
    {
        Label: "Teynampet / Ramee Mall / Anna Salai",
        Value: 9
    },
    {
        Label: "Kukatpally (Manjeera Mall)",
        Value: 10
    },
    {
        Label: "Vishakapatnam (Murli Nagar)",
        Value: 11
    },
]

const PaymentInvoiceCreation = () => {
    const title = "Payment Invoice Creation Vendor";
    const navigate = useNavigate();
    const [IsPaymentRequestOpen, setIsPaymentRequestOpen] = useState(false);
    const [IsRemarksModalOpen, setIsRemarksModalOpen] = useState(false);
    const [isEdit, setIsEdit] = useState(false)
    const [isView, setIsView] = useState(false)
    const [isViewDetails, setIsViewDetails] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [storesList, setStoresList] = useState(StoresList)
    const _doNavToCreateRequest = () => {
        setIsPaymentRequestOpen(true);
        setIsEdit(false);
        setIsView(false);
        setIsViewDetails(false)
    }
    const _doNavToViewRequest = () => {
        setIsPaymentRequestOpen(true);
        setIsView(true);
        setIsEdit(false);
        setIsViewDetails(false)
    }
    const _doNavToEditRequest = () => {
        setIsPaymentRequestOpen(true);
        setIsView(false);
        setIsEdit(true);
        setIsViewDetails(false)
    }
    const _doNavToPaymentlist = () => {
        navigate("/PaymentInvoiceCreation");
    }
    const _doCloseModal = () => {
        setIsPaymentRequestOpen(false);
        setIsEdit(false)
        setIsView(false)
        setIsViewDetails(false)
    }
    const _doOpenRemarksModal = () => {
        setIsModalOpen(true);
        setIsRemarksModalOpen(true)
    }
    const _doCloseRemarksModal = () => {
        setIsModalOpen(false);
        setIsRemarksModalOpen(false)
    }
    const _doSelectVender = () => {

    }
    const _doNavToPaymentDetails = () => {
        setIsPaymentRequestOpen(true);
        setIsView(false);
        setIsEdit(false);
        setIsViewDetails(true)
    }
    const TableData = [
        {
            key: '1',
            StoreName: "ELECTRICAL",
            ContractName: "TRANSFORMER",
            InvoiceNumber: "IN12344 ",
            InvoiceDate: "05-08-2021",
            CreatedDate: "05-12-2021",
            Amount: "10000",
            GST: "10",
            GSTAmount: "100",
            TotalAmount: "10100",
            Status: "Accepted",
            Remarks: "Remarks"
        },
        {
            key: '2',
            StoreName: "ELECTRICAL",
            ContractName: "TRANSFORMER",
            InvoiceNumber: "IN12344 ",
            InvoiceDate: "05-08-2021",
            CreatedDate: "05-12-2021",
            Amount: "10000",
            GST: "10",
            GSTAmount: "100",
            TotalAmount: "10100",
            Status: "Rejected",
            Remarks: "Remarks"
        },
        {
            key: '3',
            StoreName: "ELECTRICAL",
            ContractName: "TRANSFORMER",
            InvoiceNumber: "IN12344 ",
            InvoiceDate: "05-08-2021",
            CreatedDate: "05-12-2021",
            Amount: "10000",
            GST: "10",
            GSTAmount: "100",
            TotalAmount: "10100",
            Status: "Payment Processed",
            Remarks: "Remarks"
        }

    ]
    const TableColumns = [
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => (
                <Space size="middle">
                    <div className="table-icons">
                        <i className="fa fa-eye orange" onClick={_doNavToViewRequest}></i>
                        <i className="fa fa-pencil blue" onClick={_doNavToEditRequest}></i>
                    </div>
                </Space>
            ),
        },
        {
            title: "Store Name",
            dataIndex: "StoreName",
            key: "StoreName"
        },
        {
            title: "Contract Name",
            dataIndex: "ContractName",
            key: "ContractName"
        },
        {
            title: "Invoice Number",
            dataIndex: "InvoiceNumber",
            key: "InvoiceNumber"
        },
        {
            title: "Invoice Date",
            dataIndex: "InvoiceDate",
            key: "InvoiceDate"
        },
        {
            title: "Created Date",
            dataIndex: "CreatedDate",
            key: "CreatedDate"
        },
        {
            title: "Amount",
            dataIndex: "Amount",
            key: "Amount"
        },
        {
            title: "GST",
            dataIndex: "GST",
            key: "GST"
        },
        {
            title: "GST Amount",
            dataIndex: "GSTAmount",
            key: "GSTAmount"
        },
        {
            title: "Total Amount",
            dataIndex: "TotalAmount",
            key: "TotalAmount"
        },
        {
            title: "Status",
            dataIndex: "Status",
            key: "Status"
        },
        {
            title: "Remarks",
            dataIndex: "Remarks",
            key: "Remarks",
            render: (text, record) => (
                <Space size="middle">
                    <div className="table-icons">
                      <i onClick={_doOpenRemarksModal} className="fa fa-eye blue"></i>
                    </div>
                </Space>
            )
        }

    ]
    return (
        <div className="wrapper">
            <Header title={title} />
            <Menu1 />
            {
                IsRemarksModalOpen == true ?
                    <Modal
                    open={isModalOpen} title="Remarks"

                        footer={[
                            <button type='button' onClick={_doCloseRemarksModal} className='btn muted-button  deca-btn-orange'>Close</button>
                        ]}
                    >
                        <div className="">
                        <ul className="remarks__list">
                                <li className="remarks__item">
                                    <div className="remarks__userdetails">
                                        <h5>Karthik</h5>
                                        <h5>On 12 Aug 2021 10:45 AM</h5>
                                    </div>
                                    <div className="remarks__reason">
                                        <p>Change date and time</p>
                                    </div>
                                </li>
                                <li className="remarks__item">
                                    <div className="remarks__userdetails">
                                        <h5>Karthik</h5>
                                        <h5>On 12 Aug 2021 10:45 AM</h5>
                                    </div>
                                    <div className="remarks__reason">
                                        <p>Change date and time</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </Modal> : null
            }
            <div className='content-wrapper'>
                <div className="m-btn-block">
                    <div className="m-btn-block__container">
                        <div className="m-btn-block__icon">
                            <i class="fa fa-plus-circle" aria-hidden="true"></i>
                        </div>
                        <div className="m-btn-block__btns">
                            <button type='submit' onClick={_doNavToCreateRequest} className='btn btn-secondary deca-btn-yellow'>Create Payment Request</button>
                        </div>
                    </div>
                </div>
                <section className='content top-space'>
                    <div className="m-panel">
                        <div className="m-panel__body p10">
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor='exampleInput'>State*</label>
                                        <Select className="form-control"
                                            showSearch
                                            onChange={_doSelectVender}
                                            placeholder="-- Please Select --"
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            <Option value="1">State 1</Option>
                                            <Option value="2">State 2</Option>
                                            <Option value="3">State 3</Option>
                                            <Option value="4">State 4</Option>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor='exampleInput'>City*</label>
                                        <Select className="form-control"
                                            showSearch
                                            onChange={_doSelectVender}
                                            placeholder="-- Please Select --"
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            <Option value="1">City 1</Option>
                                            <Option value="2">City 2</Option>
                                            <Option value="3">City 3</Option>
                                            <Option value="4">City 4</Option>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor='exampleInput'>Store*</label>
                                        <Select className="form-control"
                                            showSearch
                                            onChange={_doSelectVender}
                                            placeholder="-- Please Select --"
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        > {
                                                StoresList.map((item =>
                                                    <Option value={item.Value}>{item.Label}</Option>
                                                ))
                                            }
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor='exampleInput'>Status*</label>
                                        <Select className="form-control"
                                            showSearch
                                            onChange={_doSelectVender}
                                            placeholder="-- Please Select --"
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            <Option value="1">Pending</Option>
                                            <Option value="2">Accepted</Option>
                                            <Option value="3">Rejected</Option>
                                            <Option value="4">Payment Processed</Option>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-md-3 btn-m-bottom">
                                    <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow btn-m-right'>
                                        <i className="fa fa-search"></i>
                                    </button>
                                    <button type='submit' className='btn btn-icon btn-secondary deca-btn-yellow btn-m-right'><i className="fa fa-download"></i></button>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="m-panel">
                        <div className="m-panel__body p10">
                            <div className="m-table__main">
                                <div className="m-table__responsive medium-width">
                                    <Table scroll={{y:300}} pagination={false} columns={TableColumns} dataSource={TableData} />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer />
            {
                IsPaymentRequestOpen === true ?
                    <div className="m-modal">
                        <div className="m-modal__container">
                            <div className="m-modal__header">
                                {
                                    isEdit === false && isView === false && isViewDetails === false ?
                                        <h5 className="m-modal__title">Create Payment Request </h5> : null
                                }
                                {
                                    isEdit === true && isView === false ?
                                        <h5 className="m-modal__title">Edit - Payment Request</h5> : null
                                }
                                {
                                    isView === true && isEdit === false ?
                                        <h5 className="m-modal__title">View - Payment Request</h5> : null
                                }
                                {
                                    isViewDetails === true && isView === false && isEdit === false ?
                                        <h5 className="m-modal__title">View - Payment Details</h5> : null
                                }
                                <span className="m-modal__close" onClick={_doCloseModal}>
                                    <i className="fa fa-close"></i>
                                </span>
                            </div>
                            <div className="m-modal__body">

                                {
                                    isViewDetails === true ?
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor='exampleInput'>Payment Date*</label>
                                                    <DatePicker className="form-control" disabled />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor='exampleInput'>Document Number*</label>
                                                    <input type="text" className="form-control" disabled />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor='exampleInput'>Payee Number*</label>
                                                    <input type="text" className="form-control" disabled />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor='exampleInput'>Document Number*</label>
                                                    <input type="text" className="form-control" disabled />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor='exampleInput'>Alpha Name*</label>
                                                    <input type="text" className="form-control" disabled />
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className="row">
                                            {
                                                isEdit === true ?
                                                    <div className="col-md-12 status_remarks">
                                                        <span className="pmp_status text-danger">Rejected</span>
                                                        <span className="text-primary">View Remarks</span>
                                                    </div> : null
                                            }
                                            {
                                                isView === true ?
                                                    <div className="col-md-12 status_remarks">
                                                        <span className="pmp_status text-success">Accepted</span>
                                                        <span className="text-primary">View Remarks</span>
                                                    </div> : null
                                            }

                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor='exampleInput'>Store*</label>
                                                    <Select className="form-control"
                                                        disabled={isView}
                                                        showSearch
                                                        onChange={_doSelectVender}
                                                        placeholder="-- Please Select --"
                                                        optionFilterProp="children"
                                                        filterOption={(input, option) =>
                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                        }
                                                    >
                                                        <Option value='1'>Store 1</Option>
                                                        <Option value='2'>Store 2</Option>
                                                        <Option value='3'>Store 3</Option>
                                                        <Option value='4'>Store 4</Option>
                                                        <Option value='5'>Store 5</Option>
                                                    </Select>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor='exampleInput'>GST Number*</label>
                                                    <input type="text" className="form-control" disabled />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor='exampleInput'>Decatholon GST Number*</label>
                                                    <input type="text" className="form-control" disabled={isView} />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor='exampleInput'>Decatholon Third Code*</label>
                                                    <input type="text" className="form-control" disabled />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor='exampleInput'>Contract Name*</label>
                                                    <input type="text" className="form-control" disabled />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor='exampleInput'>Vendor GST Number*</label>
                                                    <input type="text" className="form-control" disabled={isView} />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor='exampleInput'>HSN/SAC Number*</label>
                                                    <input type="text" className="form-control" disabled={isView} />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor='exampleInput'>Nature of Service*</label>
                                                    <input type="text" className="form-control" disabled={isView} />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor='exampleInput'>Contract Start Date</label>
                                                    <DatePicker className="form-control" disabled />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor='exampleInput'>Contract End Date</label>
                                                    <DatePicker className="form-control" disabled />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor='exampleInput'>Invoice Number*</label>
                                                    <input type="text" className="form-control" disabled={isView} />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor='exampleInput'>Invoice Date</label>
                                                    <DatePicker className="form-control" disabled={isView} />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor='exampleInput'>Base Value*</label>
                                                    <input type="text" className="form-control" disabled={isView} />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor='exampleInput'>GST %*</label>
                                                    <input type="text" className="form-control" disabled={isView} />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor='exampleInput'>GST Value*</label>
                                                    <input type="text" className="form-control" disabled />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor='exampleInput'>Total Amount*</label>
                                                    <input type="text" className="form-control" disabled />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    {
                                                        isView === true ?
                                                            <label htmlFor='exampleInput'>View Invoice Document*</label> :
                                                            <label htmlFor='exampleInput'>Upload Invoice Document*</label>
                                                    }
                                                    {
                                                        isView === true ?
                                                            <ol>
                                                                <li className="text-primary">InvoiceDocument1.pdf</li>
                                                                <li className="text-primary">InvoiceDocument2.pdf</li>
                                                            </ol> :
                                                            <input type="file" className="form-control" />
                                                    }

                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    {
                                                        isView === true ?
                                                            <label htmlFor='exampleInput'>View Service Document*</label> :
                                                            <label htmlFor='exampleInput'>Upload Service Document*</label>
                                                    }
                                                    {
                                                        isView === true ?
                                                            <ol>
                                                                <li className="text-primary">InvoiceDocument1.pdf</li>
                                                                <li className="text-primary">InvoiceDocument2.pdf</li>
                                                            </ol> :
                                                            <input type="file" className="form-control" />
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor='exampleInput'>Reference ID*</label>
                                                    <input type="text" className="form-control" disabled={isView} />
                                                </div>
                                            </div>

                                            <div className="col-md-12 text-center">
                                                <div className="m-page__button top-space text-center">

                                                    {
                                                        isView === true ?
                                                            <button type='button' className='btn btn-secondary deca-btn-yellow text-right' onClick={_doNavToPaymentDetails}>View Payment Details</button>
                                                            : null
                                                    }

                                                    {!isView ? <button type='button' onClick={_doNavToPaymentlist} className='btn muted-button deca-btn-orange'>Cancel</button> : null}

                                                    {!isView ? <button type='button' className='btn btn-secondary deca-btn-yellow'>Submit</button> : null}

                                                </div>
                                            </div>
                                        </div>
                                }

                            </div>
                        </div>
                    </div>
                    : false
            }
            {
                IsPaymentRequestOpen === true ?
                    <div className="overlay" onClick={_doCloseModal}>

                    </div>
                    : false
            }
        </div>
    )
}

export default PaymentInvoiceCreation
